import qs from 'qs';
import FileDownload from 'react-file-download'
import irelandApi from '../irelandApi';
import {
  GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_PENDING,
  GET_INDIVIDUAL_POINTS_STATEMENT_PENDING,
  GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_FULFILLED,
  GET_INDIVIDUAL_POINTS_STATEMENT_FULFILLED,
  GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_REJECTED,
  GET_INDIVIDUAL_POINTS_STATEMENT_REJECTED
} from '../reducers/pointsStatementReducer';

export const getOutletsForIndividualPointsStatement = () => (dispatch) => {
  dispatch({type: GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_PENDING});
  return irelandApi.get(`/api/points_statement/outlets`)
    .then((response) => {
      dispatch({
        type:    GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type:    GET_INDIVIDUAL_POINTS_STATEMENT_OUTLETS_REJECTED,
        payLoad: error.data
      })
    })
};

export const getIndividualPointsStatement = (pot, page, filters = {}) => (dispatch) => {
  dispatch({ type: GET_INDIVIDUAL_POINTS_STATEMENT_PENDING });
  
  const params = {
    page,
    pot,
    filters
  };

  return irelandApi.get(`/api/points_statement?${qs.stringify(params, {encodeValuesOnly: true})}`)
    .then((response) => {
      dispatch({
        type: GET_INDIVIDUAL_POINTS_STATEMENT_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_INDIVIDUAL_POINTS_STATEMENT_REJECTED,
        payLoad: error.data
      })
    });
};

export const downloadPoints = (pot) => {
  return irelandApi.get(`/api/points_statement.csv?pot=${pot}`)
                   .then((response) => {
                      let filename = "reward_statements.csv";
                      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                      const matches = filenameRegex.exec(response.headers['content-disposition']);
                      if (matches && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                      }
                      FileDownload(response.data, filename);
                    })
                   .catch((error) => {});
};



// WEBPACK FOOTER //
// ./src/actions/points-statement.js